import { createFeature, createReducer, on } from '@ngrx/store';
import { ApplicationConfiguration } from '../../../camms-risk/models/application-configuration/application-configuration';

import * as AppConfigActions from './application-configuration.action';

const initialState: ApplicationConfiguration = {
    progressThreshold: undefined,
    settings: undefined,
    parameters: undefined,
    activatedProducts: undefined,
};

export const appConfigFeature = createFeature({
    name: 'appConfig',
    reducer: createReducer(
        initialState,
        on(AppConfigActions.setApplicationConfigurations, (state, data) => ({
            ...state,
            progressThreshold: data.appConfig.progressThreshold,
            settings: data.appConfig.settings,
            parameters: data.appConfig.parameters,
            activatedProducts: data.appConfig.activatedProducts,
        })),
    ),
});

export const {
    name, // feature name
    reducer, // feature reducer
    selectAppConfigState, // feature selector
    selectProgressThreshold, // selector for `progressThreshold` property
    selectSettings, // selector for `settings` property
    selectParameters,
    selectActivatedProducts,
} = appConfigFeature;
